import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let detailNavTriggers: ScrollTrigger[] = [];
let detailNavClickHandler: ((event: MouseEvent) => void) | null = null;

function clickHandler(event: MouseEvent) {
  const target = (event.target as HTMLElement).closest("[data-scroll]");

  if (!target) return;

  const href =
    target.getAttribute("href") || target?.getAttribute("data-scroll");

  if (!href) return;
  if ((href[0] != "#" && !href.startsWith("/#")) || href == "#") return;

  const selector = href.replace("/#", "#");
  const element = document.querySelector<HTMLElement>(selector);

  if (!element) return;
  event.preventDefault();
  const offset = getComputedStyle(element).scrollPaddingTop ? parseFloat(getComputedStyle(element).scrollPaddingTop) : 64;

  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}

const initDetailNavSpy = () => {
  const nav = document.querySelector<HTMLElement>(".detail-nav-btns");
  if (!nav) return;

  const links = Array.from(
    nav.querySelectorAll<HTMLElement>("[data-scroll]")
  );
  if (!links.length) return;

  const items = links
    .map((link) => {
      const href =
        link.getAttribute("href") || link.getAttribute("data-scroll");
      if (!href) return null;
      const selector = href.replace("/#", "#");
      const target = document.querySelector<HTMLElement>(selector);
      if (!target) return null;
      return { link, target };
    })
    .filter((item): item is { link: HTMLElement; target: HTMLElement } =>
      Boolean(item)
    );

  if (!items.length) return;

  const setActive = (activeLink: HTMLElement) => {
    links.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle("btn-fill", isActive);
      link.classList.toggle("btn-hover-contur", !isActive);
    });
  };

  gsap.registerPlugin(ScrollTrigger);
  detailNavTriggers.forEach((trigger) => trigger.kill());
  detailNavTriggers = [];


  const separator = document.querySelector('.detail-content-separator')
  const separatorMargin = parseFloat(getComputedStyle(separator!).marginBlockStart);

  const triggerOffset = 120;
  const targetOffset = isNaN(separatorMargin) ? 30 : separatorMargin - 1;

  items.forEach((item) => {
    const trigger = ScrollTrigger.create({
      trigger: item.target,
      start: `top-=${targetOffset} top+=${triggerOffset}`,
      end: `bottom+=${targetOffset} top+=${triggerOffset}`,
      onEnter: () => setActive(item.link),
      onEnterBack: () => setActive(item.link),
    });
    detailNavTriggers.push(trigger);
  });

  ScrollTrigger.refresh();
  const activeTrigger = detailNavTriggers.find((trigger) => trigger.isActive);
  if (activeTrigger) {
    const match = items.find((item) => item.target === activeTrigger.trigger);
    if (match) {
      setActive(match.link);
    }
  } else {
    setActive(items[0].link);
  }

  detailNavClickHandler = (event: MouseEvent) => {
    const target = (event.target as HTMLElement).closest("[data-scroll]");
    if (!target) return;
    setActive(target as HTMLElement);
  };
  nav.addEventListener("click", detailNavClickHandler);
};

const init = () => {
  document.addEventListener("click", clickHandler);
  initDetailNavSpy();
};

const destroy = () => {
  document.removeEventListener("click", clickHandler);
  detailNavTriggers.forEach((trigger) => trigger.kill());
  detailNavTriggers = [];

  const nav = document.querySelector<HTMLElement>(".detail-nav-btns");
  if (nav && detailNavClickHandler) {
    nav.removeEventListener("click", detailNavClickHandler);
  }
  detailNavClickHandler = null;
};

export default { init, destroy };
